import React, { createContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const InfoCuentasContext = createContext();

/**
 * Session profile plus every store the person takes part in.
 *
 * `tiendas` is an array. It used to be the string 'si' / 'no', which meant
 * consumers could not tell "no stores" from "not loaded yet" — and `'no'`
 * is truthy, so a plain `if (tiendas)` read as "has stores". `cargando`
 * now carries that distinction instead.
 */
export const InfoCuentasProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [idcuenta, setIdCuenta] = useState('');
  const [tiendas, setTiendas] = useState([]);
  const [perfil, setPerfil] = useState(null);
  const [cargando, setCargando] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const rutasConSesion = ['/', '/cuenta'];
    if (!rutasConSesion.includes(location.pathname)) return undefined;

    let cancelado = false;

    const fetchInfoCuentas = async () => {
      setCargando(true);
      try {
        const response = await fetch('/api/infocuentas', { credentials: 'include' });

        if (cancelado) return;

        if (response.status === 401) {
          setIsAuthenticated(false);
          setTiendas([]);
          return;
        }

        const data = await response.json();
        if (cancelado) return;

        // Without this the flag is one-way: a 401 on some earlier route left
        // it false forever, so /cuenta bounced to home even after signing in.
        setIsAuthenticated(true);
        setIdCuenta(data.idcuenta);
        setTiendas(Array.isArray(data.tiendas) ? data.tiendas : []);
        setPerfil({
          mail: data.mail,
          nombre: data.nombre,
          direccion: data.direccion,
          telefono: data.telefono,
        });
      } catch (error) {
        if (!cancelado) setTiendas([]);
        console.error('Error al obtener la info de cuenta:', error);
      } finally {
        if (!cancelado) setCargando(false);
      }
    };

    fetchInfoCuentas();
    return () => { cancelado = true; };
  }, [location.pathname]);

  return (
    <InfoCuentasContext.Provider
      value={{ isAuthenticated, idcuenta, tiendas, perfil, cargando }}
    >
      {children}
    </InfoCuentasContext.Provider>
  );
};
